import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 text-center" }

import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ChatHideLink"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["click"],
  setup(__props, { emit: __emit }) {

let emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "link-dashed text-muted",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
    }, _toDisplayString(_unref(__)('HIDE')), 1)
  ]))
}
}

})